import PayPalLogo from '@/components/icons/PayPalLogo'
import StripeConnectLogo from '@/components/icons/StripeConnectLogo'
import GiddyUpLarge from '@/components/icons/GiddyUpLarge'

export const PROVIDERS = {
    paypal: {
        label: 'PayPal',
        type: 'paypal',
        link: 'https://www.paypal.com/',
        loginUrl: 'https://www.paypal.com/signin',
        description: 'Link your existing PayPal account to receive payouts from GiddyUp.',
    },
    stripe: {
        label: 'Stripe',
        type: 'stripe',
        link: 'https://stripe.com/',
        loginUrl: 'https://dashboard.stripe.com/login',
        description: 'Create a new Stripe Connected Account under the GiddyUp Platform.',
    },
    giddyup: {
        label: 'GiddyUp',
        type: 'giddyup',
        link: '',
        loginUrl: '',
        description: 'Complete the Payment Authorization Form to add your backup payment method.',
    },
}

export const PROVIDER_LOGOS = {
    [PROVIDERS.paypal.type]: <PayPalLogo sx={{ width: 130, height: 32 }} />,
    [PROVIDERS.stripe.type]: (
        <StripeConnectLogo sx={{ width: 200, height: 120, mt: -5.5, ml: -2 }} />
    ),
    [PROVIDERS.giddyup.type]: <GiddyUpLarge sx={{ width: 100, height: 'auto' }} />,
}

export const PROVIDER_CONFIGURATION = {
    ACCOUNT: 'account',
    ACCOUNT_INCOMPLETE: 'account_incomplete',
    MERCHANT_ID: 'merchant_id',
    SELLER_NONCE: 'seller_nonce',
    AUTH_CODE: 'auth_code',
    SHARED_ID: 'shared_id',
    NEEDS_PAYMENT_METHOD: 'needs_payment_method',
    PAYOUT_FAILED: 'payout_failed',
    HAS_PENDING_BALANCE: 'has_pending_balance',
}

export const getPaymentProviderByTypeAndKey = (providers, accountType, key) =>
    providers.filter(
        ({ configurations, type }) =>
            accountType === type && configurations.find((config) => config.key === key),
    )
